/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ sku: NonNullable<unknown> }} Shop_Variant_In_Stock_AriaInputs */

const vi_shop_variant_in_stock_aria = /** @type {(inputs: Shop_Variant_In_Stock_AriaInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.sku} có sẵn hàng`)
};

/**

* @param {Shop_Variant_In_Stock_AriaInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_variant_in_stock_aria = /** @type {((inputs: Shop_Variant_In_Stock_AriaInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Variant_In_Stock_AriaInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_variant_in_stock_aria(inputs)
});